<template>
  <div class="container p-5 pt-5 mt-5" style="color:#fff;">
    <div class="row p-5">
      <div class="col-md-12 text-center pt-5">
        <p>
          <i class="fa fa-exclamation-triangle fa-5x"></i><br />Status Code: 403
        </p>
      </div>
      <div class="col-md-12 text-center p-3">
        <h3>OPPSSS!!!! Sorry...</h3>
      </div>
      <div class="col-md-12 p-5 text-center" style="font-size:20px;">
        <p>
          Sorry, your access is refused due to security reasons of our server
          and also our sensitive data.<br />Please go back to the previous page
          to continue browsing.
        </p>
        <div class="p-5">
          <a
            class="btn btn-lg btn-danger"
            href="/"
            @click="
              () => {
                this.$root.logout();
              }
            "
            >Go Back</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped></style>
